import SimpleCard from './SimpleCard';
import ImageCard from './ImageCard';
import SingleActionMinimalCard from './SingleActionMinimalCard';
import EnhancedImageCard from './EnhancedImageCard';

export const SIMPLECARD = SimpleCard;
export const IMAGECARD = ImageCard;
export const SIGNLEACTIONMINIMALCARD = SingleActionMinimalCard;
export const ENHANCEDIMAGECARD = EnhancedImageCard;
